import pb from '../lib/pocketbase';

/**
 * Fetch a paginated list of escoltas from the database.
 * @param {number} page - The page number.
 * @param {number} perPage - The number of items per page.
 * @returns {Object} - A list of escoltas and pagination details.
 */
export async function getEscoltas(page, perPage) {
  return await pb.collection('escolta').getList(page, perPage, {
    sort: '-created', // Sort by creation date in descending order
    $autoCancel: false, // Prevent automatic cancellation of the request
    // expand: 'vehiculoAsignado', // Remove or comment out this line
  });
}

/**
 * Create a new escolta in the database.
 * @param {Object} escolta - The escolta object to create.
 * @returns {Object} - The created escolta.
 */
export async function createEscolta(escolta) {
  return await pb.collection('escolta').create(escolta);
}

/**
 * Update an existing escolta in the database.
 * @param {string} id - The ID of the escolta to update.
 * @param {Object} escolta - The updated escolta object.
 * @returns {Object} - The updated escolta.
 */
export async function updateEscolta(id, escolta) {
  return await pb.collection('escolta').update(id, escolta);
}

/**
 * Delete an escolta from the database.
 * @param {string} id - The ID of the escolta to delete.
 * @returns {boolean} - True if the deletion was successful.
 */
export async function deleteEscolta(id) {
  return await pb.collection('escolta').delete(id);
}